function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_x33_"
}, /*#__PURE__*/React.createElement("g", {
  id: "A_2_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.5,15.8l-0.8,2.3l-4.1,0.8l1.4-3.8l3.1-2.7l-2.2,0.4L53,4.4l3.6-2.2L62,14.5l-3.5,2.4L58,15.6l0.8-1L52.5,15.8z  M53.6,12.6l3.2-0.6l-1.5-4.9l0,0l0,0L53.6,12.6z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "59.4,17.3 63,14.8 61.7,17.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "56.8,16.2 56,17.1 57,17.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "48.2,13.5 47.4,15.1 49.6,13.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "53.4,3.3 55.5,2 53.7,2.3  "
})), /*#__PURE__*/React.createElement("g", {
  id: "B_2_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.8,6.2c0.7,0.6,0.9,1.4,0.9,2.3c0,1.2-0.5,2.4-1.8,3.4c2.4,0.4,2.5,2.4,2.5,3c0,0.8-0.2,1.8-0.7,2.6l-2,0.4 c0,0-1.3,1.1-1.3,1.1s2.5-0.5,2.5-0.5c-1.3,1.3-2.3,1.6-4.8,2.1l-4.8,0.9V9.4L36.4,7l-3.1,1V6.6L38,5.7c1.8-0.4,3-0.4,3.9-0.1 l-3.2,1.7L42.8,6.2z M37,10.9l-1.2,0.9l2.6-0.5C38.9,11.2,40,11,40,9.8c0-1.1-1-0.9-1.6-0.8L37,9.2V10.9z M37,17.5l1.8-0.3 c0.5-0.1,1.9-0.4,1.9-1.8c0-1.3-1.3-1.1-1.9-0.9L37,14.8V17.5z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.1,20.7 47.4,19 47.8,17.7 38.9,19.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "40.2,18.2 45,17.3 45.2,16.7 40.6,17.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "32.2,8.4 33.1,8.7 32.1,10.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "42.6,5.8 44,5.1 43.6,4.7  "
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041C_2_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3,19l-1.6-5.1l0,0l0.1,11.3l-3.5,0.7V12.3l4.9-2.4l2.6,7.8L16.3,19z M19.4,18.6L19.4,18.6l2.8-9.8l5-0.9v15.1 l-3.5,0.7l0.1-7l2.3-2.1l-2.3,1l0-3.2l0,0l-3.2,11.9l-2.5,0.5l-1.2-4.1L19.4,18.6z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "22.1,21.6 21.3,27 22.5,25.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "18.7,12.4 19.2,14.7 19.5,13.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "17.7,11.4 16.7,8 18,7.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "18.2,11.2 18.5,9.7 18.9,10.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "10.7,11.5 14.3,9.9 10.1,10.7  "
})), /*#__PURE__*/React.createElement("g", {
  id: "I_2_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.8,21.2v6L0,28v-5.2L3.8,21.2z M0,21.9v-9l3.8,0.3v6.4L0,21.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "4.2,28 0.8,28.5 4.2,29.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0.9,29.1 2.8,29.4 0.6,30  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0.1,11.9 4.5,12.1 4.2,11  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "2,10.5 0.6,11.3 0.6,10.5  "
})), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u0417\\u0435\\u043B\\u0435\\u043D\\u0430\\u044F_\\u043F\\u043B\\u0430\\u0448\\u043A\\u0430_3_",
  className: "st0",
  points: "62.3,21.3 27,26.8 27.2,28.3 62.2,22.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u041F\\u043B\\u0430\\u0448\\u043A\\u0430_\\u0431\\u0435\\u043B\\u0430\\u044F_2_",
  points: "44.8,21.4 33.3,24 33.8,24.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u0411\\u0435\\u043B\\u044B\\u0439_\\u0442\\u0440\\u0435\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_2_",
  className: "st0",
  points: "50.9,1.7 48.8,9 47,5.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u0417\\u0435\\u043B\\u0451\\u043D\\u044B\\u0439_\\u0442\\u0440\\u0435\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_3_",
  className: "st0",
  points: "46.9,1.6 48.7,2 47.5,3  "
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 32",
    style: {
      enableBackground: "new 0 0 63 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.253de274.svg";
export { ForwardRef as ReactComponent };